<template>
  <div>
      <div class="clearfix table-tools">
        <div class="buttons"></div>
        <div class="search">
          <a-form layout='inline' @submit="searchList">
              <a-form-item>
                <a-tooltip placement="topLeft" >
                  <a-date-picker
                      v-model="searchData.date"
                      :disabled-date="disabledDate"
                      @change="handleDateChange"
                      placeholder="选择日期"
                    />
                </a-tooltip>
            </a-form-item>
            <!-- <a-form-item>
              <a-button type="primary" html-type="submit" @click="searchList">搜索</a-button>
            </a-form-item> -->
          </a-form>
        </div>
      </div>
      <div class="table">
        <vue-element-loading :active="loading" color="#00cca2" spinner="spinner"/>
        <a-table size="middle" :pagination="false" :bordered='false' rowKey="id"
          :columns="columns" @change="handleChange" :dataSource="list" v-if="false">
            <template slot="index" slot-scope="text, record , index">
              <span>{{(index+1) + pageParams.perPage * (pageParams.currentPage - 1)}}</span>
            </template>
            <template slot="opt_content" slot-scope="text">
              <div v-html="text"></div>
            </template>
            <template slot="stock_name" slot-scope="text, record , index">
                <span @click.stop v-clipboard:copy="record.stock_code" >{{text}}</span>
                <a-tag color="red" v-for="(data,index) in record.stock_short_tag" :key="index">
                  {{data}}
                </a-tag>
            </template>
            <template slot="stock_code" slot-scope="text, record , index">
                <a-badge :count="record.stock_kick_count" :offset=[15,0] :number-style="{
        backgroundColor: '#fff',
        color: 'red',
        boxShadow: '0 0 0 1px #d9d9d9 inset',
      }">
                  <span @click="clk(record.stock_code,record)">{{text}}</span>
                </a-badge>
            </template>
            <template slot="price" slot-scope="text, record , index">
                <span :style="color(text)"> {{ (formatNumber(text)) }}</span>
            </template>
            <template slot="B" slot-scope="text, record , index">
                <span>{{record.stock_bsm.rocket_buy}}</span>
            </template>
            <template slot="stock_chengjiaocha" slot-scope="text, record , index">
              <a-progress :percent="text" size="small" :show-info="false" />
            </template>
            <template slot="S" slot-scope="text, record , index">
                <span>{{record.stock_bsm.rocket_sell}}</span>
            </template>
        </a-table>
      </div>
      <div class="page" v-if="false">
        <a-pagination
          :pageSizeOptions="pageSizeOptions"
          :total="pageParams.totalCount"
          showSizeChanger
          :pageSize="pageParams.perPage"
          v-model="current"
          @change="changePage"
          @showSizeChange="onShowSizeChange"
          :showTotal="total => `共 ${pageParams.totalCount.toLocaleString()}条 `"
        >
            <template slot='buildOptionText' slot-scope='props'>
              <span v-if="props.value!=='100'">{{props.value}}条/页</span>
              <span v-if="props.value==='100'">100条/页</span>
            </template>
          </a-pagination>
      </div>

      <!-- <a-modal v-model="editVisible" :title="stock_title" cancelText="取消" okText="刷新" width="1550px" @ok="handleOk" > -->
        <vue-element-loading :active="loadingP" color="#00cca2" spinner="spinner"/>
      <a-row :gutter="[16,8]">
        <a-col :span="6" v-for="(mainData, index) in predictLiuruChart">
            <ve-histogram 
            :data="mainData" 
            height="300px"
            width="400px"
            :legend="{show:true,bottom:10}"
            judge-width
            :grid="{right: '5%'}"
            :mark-line="markLine"
            :title="{
                text:mainData.name,
                textStyle: {
                    fontSize: 15,
                },
                subtextStyle: {
                    fontSize: 12.5
                }
            }"
            :settings="{
                label: { show: false, position: 'top'},
                yAxisType: ['KMB', 'KMB'], 
                showLine: ['930','931','932'],
                axisSite: { right: [] }, 
            }" 
            :extend="histogramChartExtend" ></ve-histogram>
        </a-col>
      </a-row>

            <ve-histogram 
            v-if="false"
            :data="predictChart" 
            :legend="{show:true,bottom:10}"
            judge-width
            :grid="{right: '5%'}"
            :mark-line="markLine"
            :title="{
                text:`${predictChart.title}`,
                textStyle: {
                    fontSize: 15,
                },
                subtextStyle: {
                    fontSize: 12.5
                }
            }"
            :settings="{
                label: { show: false, position: 'top'},
                yAxisType: ['KMB', 'KMB'], 
                showLine: ['M'],
                axisSite: { right: ['M'] }, 
            }" 
            :extend="histogramChartExtend" ></ve-histogram>


            <a-card v-for="(tableData, index) in kick_his_list" v-if="false">
                <a-table size="small" :pagination="false" :bordered='false' rowKey="id"
                    :columns="ztcolumns" :dataSource="tableData">
                    <template slot="index" slot-scope="text, record , index">
                    <span>{{(index+1)}}</span>
                    </template>
                    <template slot="price" slot-scope="text, record , index">
                    <span :style="color(text)"> {{ (formatNumber(text)) }}</span>
                    </template>
                </a-table>
            </a-card>

            <a-table size="small" :pagination="false" :bordered='false' rowKey="id"
                :columns="columns2" :dataSource="liuruList" v-if="false">
                <template slot="index" slot-scope="text, record , index">
                <span>{{(index+1)}}</span>
                </template>
                <template slot="price" slot-scope="text, record , index">
                <span :style="color(text)"> {{ (formatNumber(text)) }}</span>
                </template>
            </a-table>

            <template>
            <!-- <a-timeline>
                <a-timeline-item :color="msg.color" v-for="(msg,index) in predictMsg" :key="index">{{msg.stock_date}} {{msg.tm}} {{msg.msg}}</a-timeline-item>
            </a-timeline> -->

        </template>
        <LEmpty v-if="first>0 && predictChart.rows.length == 0"/>
      <!-- </a-modal> -->

      <a-modal v-model="dVisible" :title="concept_name + ' ' + searchData.date"  cancelText="取消" okText="刷新" width="1750px">
      <vue-element-loading :active="dlLoading" color="#00cca2" spinner="spinner"/>
          <a-radio-group :value="searchData.bk_date" @change="handleButDateChange">
              <a-radio-button :value="data.日期" v-for="data in liuruChart.rows" v-if="data.日期.length < 6">
              {{data.日期}}
              </a-radio-button>
          </a-radio-group>

          <hr />

          <a-radio-group :value="searchData.shsz" @change="handleModalButChange">
              <a-radio-button value="sh">
              主板
              </a-radio-button>
              <a-radio-button value="sz">
              创业
              </a-radio-button>
          </a-radio-group>

          <a-radio-group>
              <a-radio-button value="1" @click="handleButAddChange()">
              +
              </a-radio-button>  
          </a-radio-group>

          <hr/>

          <a-radio-group :value="searchData.bk_stock_type" @change="handleButTypeChange">
              <a-radio-button value="">
              全部
              </a-radio-button>
              <a-radio-button value="small">
                < 30
              </a-radio-button>
              <a-radio-button value="middle">
                < 50
              </a-radio-button>
          </a-radio-group>
          <hr/>

          <a-radio-group :value="searchData.bk_sort" @change="handleSort">
            <a-radio-button :value="data" :key="idx" v-for="(idx,data) in sort_list">
                {{idx}}
              </a-radio-button>
          </a-radio-group>
          <hr/>

          <a-table size="small" :pagination="false" :bordered='false' rowKey="code" :columns="columns4" :dataSource="detail_list" @change="handleChange2">
                <template slot="index" slot-scope="text, record , index">
                    <span>{{(index+1)}}</span>
                </template>

                <template slot="price" slot-scope="text, record , index">
                    <span :style="color(text)"> {{ (formatNumber(text)) }}</span>
                </template>

                <template slot="stock_code" slot-scope="text, record , index">
                  <!-- <span @click="clk(record.stock_code,record)">{{text}}</span> -->
                   <span>{{text}}</span>
                  <!-- <a-tag color="#f50">
                    中
                  </a-tag> -->
                </template>

                <template slot="opt" slot-scope="text, record , index">
                    <span :style="{ color: text.fs_type == 'B' ? 'red' : 'green' }">{{ (formatNumber(text.fs_total)) }}</span>
                </template>
                
                <template slot="concept_name" slot-scope="text, record , index">
                  <span @click.stop v-clipboard:copy="record.stock_code">{{text}}</span>
                </template>

                <template slot="stock_zongzhi" slot-scope="text, record , index">
                    <span :style="{ color: text > 1e10 ? 'red' : '' }"> {{ (formatNumber(text)) }}</span>
                </template>

                <template slot="stock_chengjiaoe" slot-scope="text, record , index">
                    <span> {{ (formatNumber(text)) }}</span>
                </template>

                <template slot="fs_low_minute" slot-scope="text, record , index">
                    <span> {{ ((text)) }}</span>
                </template>

                <template slot="fs_one_total" slot-scope="text, record , index">
                    <!-- <span :style="{ color: record.fs_one_total.stock_is_low =='0' ? 'red' : '' }"> {{ ((text.bili)) }}</span> -->
                    <span> {{ ((text.bili)) }}</span>
                </template>

                <template slot="fs_one_total_m" slot-scope="text, record , index">
                    <span> {{ (formatNumber(text.stock_gap_total)) }}</span>
                </template>

                <template slot="stock_name" slot-scope="text, record , index">
                  <a-badge status="success" v-if="record.isHigh" />
                  <!-- <span  @click="clk_buy(record.stock_code,record.stock_name)">{{text}}</span> -->
                  <span :style="{ color: record.is_red ? 'red' : record.is_green ? 'green':'' }" @click="clk_buy(record.stock_code,record.stock_name)"> {{ (text) }}</span>
                </template>
                <template slot="stock_short_count" slot-scope="text, record , index">
                    <span>{{record.stock_yes_short_count}}/{{record.stock_short_count}}</span>
                </template>
                <template slot="stock_zhangdiefu_zuixin" slot-scope="text, record , index">
                  <span :style="zuixincolor(text,record.stock_zhangdiefu)"> {{ (formatNumber(text)) }}</span>
                </template>
            </a-table>
      </a-modal>


      <a-modal v-model="fsVisible" cancelText="取消" okText="刷新" width="1550px">
        <ve-histogram 
            :data="fs_list_chart" 
            :legend="{show:true,bottom:10}"
            judge-width
            :grid="{right: '5%'}"
            :mark-line="markLine"
            :title="{
                textStyle: {
                    fontSize: 15,
                },
                subtextStyle: {
                    fontSize: 12.5
                }
            }"
            :settings="{
                label: { show: false, position: 'top'},
                yAxisType: ['KMB', 'KMB'], 
                showLine: ['P','A'],
                axisSite: { right: ['P','A'] }, 
            }" 
            :extend="histogramChartExtend" ></ve-histogram>

        <a-row :gutter="[16,16]">
            <a-col :span="4"  v-for="(data,index) in fs_list" :key="index">
                <a-timeline>
                    <a-timeline-item :color="msg.color" v-for="(msg,index) in data" :key="index">{{msg.stock_time}} # {{msg.fs_price}} # {{msg.fs_opt}} # {{formatNumber(msg.fs_total)}} </a-timeline-item>
                </a-timeline>
            </a-col>
        </a-row>

      </a-modal>
  </div>
</template>

<script>

const ztcolumns = [
  { title: '#', width:'70px', scopedSlots: { customRender: 'index' }, key: 'id' ,sorter:()=>{}},
  { title: '涨停时间',  align:'left', dataIndex: 'stock_zhangting_shijian', key: 'stock_zhangting_shijian',sorter:()=>{}, scopedSlots: { customRender: 'stock_zhangting_shijian' }},
  { title: '股票名称',  align:'left', dataIndex: 'stock_name', key: 'stock_name',sorter:()=>{}},
  { title: '股票连板',  align:'left', dataIndex: 'kick_no', key: 'kick_no',sorter:()=>{}},
  { title: '股票代码',  align:'left', dataIndex: 'stock_code', key: 'stock_code',sorter:()=>{}, scopedSlots: { customRender: 'stock_code' }},
  { title: '主力封单',  align:'left', dataIndex: 'stock_fengdan', key: 'stock_fengdan',sorter:()=>{}, scopedSlots: { customRender: 'price' }},
  { title: '最大封单',  align:'left', dataIndex: 'stock_max_fengdan', key: 'stock_max_fengdan',sorter:()=>{}, scopedSlots: { customRender: 'price' }},
  { title: '主力净额',  align:'left', dataIndex: 'stock_zhuli_jinge', key: 'stock_zhuli_jinge',sorter:()=>{}, scopedSlots: { customRender: 'price' }},
  { title: '主力卖出',  align:'left', dataIndex: 'stock_zhuli_maichu', key: 'stock_zhuli_maichu',sorter:()=>{}, scopedSlots: { customRender: 'price' }},
  { title: '主力买入',  align:'left', dataIndex: 'stock_zhuli_mairu', key: 'stock_zhuli_mairu',sorter:()=>{}, scopedSlots: { customRender: 'price' }},
  { title: '股票板块', width: 160, align:'left', dataIndex: 'stock_bk', key: 'stock_bk',sorter:()=>{}},
  { title: '涨停原因', width: 160, align:'left', dataIndex: 'stock_reason', key: 'stock_reason',sorter:()=>{}, scopedSlots: { customRender: 'stock_bk_name' }},
]

const columns = [
  { title: '#', width:'70px', scopedSlots: { customRender: 'index' }, key: 'id' ,sorter:()=>{}},
  { title: '名称', width: 80, align:'left', dataIndex: 'stock_name', scopedSlots: { customRender: 'stock_name' }, key: 'stock_name',sorter:()=>{}},
  { title: '代码', width: 80, align:'center', dataIndex: 'stock_code', key: 'stock_code',sorter:()=>{}, scopedSlots: { customRender: 'stock_code' }},
  { title: '涨幅', width: 80, align:'center', dataIndex: 'stock_zhangdiefu', key: 'stock_zhangdiefu',sorter:()=>{}, scopedSlots: { customRender: 'price' }},
  { title: '均线', width: 80, align:'center', dataIndex: 'stock_avg_zhangdiefu', key: 'stock_avg_zhangdiefu',sorter:()=>{}},
  { title: '昨日', width: 80, align:'center', dataIndex: 'stock_yesterday_avg_zhangdiefu', key: 'stock_yesterday_avg_zhangdiefu',sorter:()=>{}, scopedSlots: { customRender: 'price' }},
  { title: '振幅', width: 80, align:'center', dataIndex: 'stock_zhenfu', key: 'stock_zhenfu',sorter:()=>{}},
  { title: '5涨速', width: 80, align:'center', dataIndex: 'stocck_5zhangsu', key: 'stocck_5zhangsu',sorter:()=>{}},
  // { title: '价格', width: 80, align:'center', dataIndex: 'stock_now', key: 'stock_now',sorter:()=>{}},
  { title: '换手', width: 80, align:'center', dataIndex: 'stock_huanshou', key: 'stock_huanshou',sorter:()=>{}},
  // { title: '量比', width: 80, align:'center', dataIndex: 'stock_liangbi', key: 'stock_liangbi',sorter:()=>{}},
  { title: '流通', align:'center', dataIndex: 'stock_liutongshizhi', key: 'stock_liutongshizhi', scopedSlots: { customRender: 'price' },sorter:()=>{}},
  { title: '成交比', align:'center', dataIndex: 'stock_chengjiaocha', key: 'stock_chengjiaocha' , scopedSlots: { customRender: 'stock_chengjiaocha' },sorter:()=>{}},
  { title: '今日成交', align:'center', dataIndex: 'stock_chengjiaoe', key: 'stock_chengjiaoe' , scopedSlots: { customRender: 'price' },sorter:()=>{}},
  { title: '昨日成交', align:'center', dataIndex: 'stock_jt_chengjiaoe', key: 'stock_jt_chengjiaoe', scopedSlots: { customRender: 'price' },sorter:()=>{}},
  { title: '净交额', align:'center', dataIndex: 'stock_sort_chengjiaoe', key: 'stock_sort_chengjiaoe' , scopedSlots: { customRender: 'price' },sorter:()=>{}},
  { title: '净流入',  align:'center', dataIndex: 'stock_liuru', key: 'stock_liuru', scopedSlots: { customRender: 'price' },sorter:()=>{}},
  { title: '净流比例',  align:'center', dataIndex: 'stock_liuru_bili', key: 'stock_liuru_bili',sorter:()=>{}},
  // { title: '净占比', align:'center', dataIndex: 'stock_liuru_zhanbi', key: 'stock_liuru_zhanbi', scopedSlots: { customRender: 'price' },sorter:()=>{}},

  // { title: 'B', align:'center', dataIndex: 'B', key: 'B', scopedSlots: { customRender: 'B' },sorter:()=>{}},
  // { title: 'S', align:'center', dataIndex: 'S', key: 'S', scopedSlots: { customRender: 'S' },sorter:()=>{}},
  // { title: 'M', align:'center', dataIndex: 'M', key: 'M', scopedSlots: { customRender: 'M' },sorter:()=>{}},

  // { title: '超大', align:'center', dataIndex: 'stock_chaoda_liuru', key: 'stock_chaoda_liuru', scopedSlots: { customRender: 'price' },sorter:()=>{}},
  // { title: '超占比', align:'center', dataIndex: 'stock_chaoda_liuru_zhanbi', key: 'stock_chaoda_liuru_zhanbi', scopedSlots: { customRender: 'price' },sorter:()=>{}},

  // { title: '大流入', align:'center', dataIndex: 'stock_da_liuru', key: 'stock_da_liuru', scopedSlots: { customRender: 'price' },sorter:()=>{}},
  // { title: '大占比',  align:'center', dataIndex: 'stock_da_liuru_zhanbi', key: 'stock_da_liuru_zhanbi', scopedSlots: { customRender: 'price' }},

  // { title: '中流入', align:'center', dataIndex: 'stock_zhong_liuru', key: 'stock_zhong_liuru', scopedSlots: { customRender: 'price' },sorter:()=>{}},
  // { title: '中占比', align:'center', dataIndex: 'stock_zhong_liuru_zhanbi', key: 'stock_zhong_liuru_zhanbi', scopedSlots: { customRender: 'price' }},

  // { title: '小流入', align:'center', dataIndex: 'stock_xiao_liuru', key: 'stock_xiao_liuru', scopedSlots: { customRender: 'price' },sorter:()=>{}},
  // { title: '小占比', align:'center', dataIndex: 'stock_xiao_liuru_zhanbi', key: 'stock_xiao_liuru_zhanbi', scopedSlots: { customRender: 'price' }},

  // { title: 'MA5', align:'center', dataIndex: 'stock_5avg', key: 'stock_5avg',sorter:()=>{}},
  // { title: 'MA10', align:'center', dataIndex: 'stock_10avg', key: 'stock_10avg',sorter:()=>{}},
  // { title: 'MA20', align:'center', dataIndex: 'stock_20avg', key: 'stock_20avg',sorter:()=>{}},
  // { title: '流入占比', width: 80, align:'center', dataIndex: 'stock_liuru_zhanbi', key: 'stock_liuru_zhanbi',sorter:()=>{}},
  { title: '板块', align:'center', dataIndex: 'stock_bk', key: 'stock_bk'},
  { title: 'time', align:'center', dataIndex: 'stock_updatetime', key: 'stock_updatetime'},
  // { title: '涨停理由', align:'center', dataIndex: 'stock_reason', key: 'stock_reason'},
]

const columns2 = [
  // { title: '#', width:'70px', scopedSlots: { customRender: 'index' }, key: 'id' },
  { title: '日期', align:'center', dataIndex: 'stock_date', key: 'stock_date'},
  { title: '开盘', align:'center', dataIndex: 'stock_jinkai', key: 'stock_jinkai'},
  { title: '价格', align:'center', dataIndex: 'stock_now', key: 'stock_now'},
  { title: '振幅', align:'center', dataIndex: 'stock_zhenfu', key: 'stock_zhenfu'},
  { title: '盘口', align:'center', dataIndex: 'stock_pankou', key: 'stock_pankou'},
  { title: '涨幅', align:'left', dataIndex: 'stock_zhangdiefu', key: 'stock_zhangdiefu', scopedSlots: { customRender: 'price' }},
  { title: '成交额', align:'center', dataIndex: 'stock_chengjiaoe', key: 'stock_chengjiaoe' , scopedSlots: { customRender: 'price' }},
  { title: '净流入',  align:'center', dataIndex: 'stock_liuru', key: 'stock_liuru', scopedSlots: { customRender: 'price' }},
  { title: '流入占比', align:'center', dataIndex: 'stock_liuru_zhanbi', key: 'stock_liuru_zhanbi', scopedSlots: { customRender: 'price' }},

  { title: '超大流入', align:'center', dataIndex: 'stock_chaoda_liuru', key: 'stock_chaoda_liuru', scopedSlots: { customRender: 'price' }},
  { title: '超大占比', align:'center', dataIndex: 'stock_chaoda_liuru_zhanbi', key: 'stock_chaoda_liuru_zhanbi', scopedSlots: { customRender: 'price' }},

  { title: '大流入', align:'center', dataIndex: 'stock_da_liuru', key: 'stock_da_liuru', scopedSlots: { customRender: 'price' }},
  { title: '大占比',  align:'center', dataIndex: 'stock_da_liuru_zhanbi', key: 'stock_da_liuru_zhanbi', scopedSlots: { customRender: 'price' }},

  { title: '中流入', align:'center', dataIndex: 'stock_zhong_liuru', key: 'stock_zhong_liuru', scopedSlots: { customRender: 'price' }},
  { title: '中占比', align:'center', dataIndex: 'stock_zhong_liuru_zhanbi', key: 'stock_zhong_liuru_zhanbi', scopedSlots: { customRender: 'price' }},

  { title: '小流入', align:'center', dataIndex: 'stock_xiao_liuru', key: 'stock_xiao_liuru', scopedSlots: { customRender: 'price' }},
  { title: '小占比', align:'center', dataIndex: 'stock_xiao_liuru_zhanbi', key: 'stock_xiao_liuru_zhanbi', scopedSlots: { customRender: 'price' }}

]

const columns4 = [
  { title: '#', width:'45px', scopedSlots: { customRender: 'index' }, key: 'id' ,sorter:()=>{}} ,
  { title: '', align:'center', dataIndex: 'stock_code', key: 'stock_code'},
  { title: '', align:'center', dataIndex: 'stock_name', key: 'stock_name', scopedSlots: { customRender: 'stock_name' }},
  // { title: 'no', align:'center', dataIndex: 'rank_no', key: 'rank_no'},
  { title: '昨', align:'center', dataIndex: 'stock_yesterday_zhangdiefu', key: 'stock_yesterday_zhangdiefu', scopedSlots: { customRender: 'price' }},
  // { title: '涨速', align:'center', dataIndex: 'stocck_5zhangsu', key: 'stocck_5zhangsu'},
//   { title: '买', align:'center', dataIndex: 'stock_kick_sale.buy', key: 'stock_kick_sale_b', scopedSlots: { customRender: 'price' }},
//   { title: '卖', align:'center', dataIndex: 'stock_kick_sale.sale', key: 'stock_kick_sale_s', scopedSlots: { customRender: 'price' }},
//   { title: '5日', width: 70, align:'center', dataIndex: 'stock_5day_zhangfu', key: 'stock_5day_zhangfu', scopedSlots: { customRender: 'price' }},
//   { title: '振幅', width: 70, align:'center', dataIndex: 'stock_5day_zhenfu', key: 'stock_5day_zhenfu'},
  // { title: '下', width: 70, align:'center', dataIndex: 'fs_low_minute', key: 'fs_low_minute', scopedSlots: { customRender: 'fs_low_minute' }},
  
  { title: 'MA', align:'center', dataIndex: 'stock_macd', key: 'stock_macd'},
//   { title: '连续', width: 70, align:'center', dataIndex: 'lxsz_count', key: 'lxsz_count',sorter:()=>{}},
  { title: '涨', align:'center', dataIndex: 'stock_zhangdiefu', key: 'stock_zhangdiefu'},
  { title: 'ZG', align:'center', dataIndex: 'stock_zhangdiefu_gap', key: 'stock_zhangdiefu_gap', scopedSlots: { customRender: 'price' }},
  { title: '收', width: 70, align:'center', dataIndex: 'stock_zhangdiefu_zuixin', key: 'stock_zhangdiefu_zuixin', scopedSlots: { customRender: 'stock_zhangdiefu_zuixin' },sorter:()=>{}},
  { title: 'OL',  align:'left', dataIndex: 'stock_930_liangbi', key: 'stock_930_liangbi'},
  { title: 'ONE', width: 70, align:'center', dataIndex: 'one_bili', key: 'one_bili'},
  { title: 'TWO', width: 70, align:'center', dataIndex: 'two_bili', key: 'two_bili'},
  
  // { title: 'ONEM', width: 100, align:'center', dataIndex: 'fs_one_total', key: 'fs_one_total_m' , scopedSlots: { customRender: 'fs_one_total_m' }},
//   { title: 'S', width: 40, align:'center', dataIndex: 'stock_short_count', key: 'stock_short_count',sorter:()=>{}},
//   { title: 'K', width: 40, align:'center', dataIndex: 'stock_kick_count', key: 'stock_kick_count',sorter:()=>{}},
  { title: '今比', width: 70, align:'center', dataIndex: 'stock_liangbi', key: 'stock_liangbi'},
  { title: '昨比', width: 70, align:'center', dataIndex: 'stock_cje_bili', key: 'stock_cje_bili'},
  { title: '五比', align:'left', dataIndex: 'yesterday_liangbi', key: 'yesterday_liangbi'},
  { title: '今成', align:'center', dataIndex: 'stock_chengjiaoe', key: 'stock_chengjiaoe' , scopedSlots: { customRender: 'stock_chengjiaoe' }},
  { title: '昨换', align:'center', dataIndex: 'stock_yesterday_huanshou', key: 'stock_yesterday_huanshou'},
  { title: '昨流', align:'center', dataIndex: 'stock_yesterday_liuru_bili', key: 'stock_yesterday_liuru_bili',sorter:()=>{}, scopedSlots: { customRender: 'price' }},
  // { title: '今流', align:'center', dataIndex: 'stock_liuru', key: 'stock_liuru',sorter:()=>{}, scopedSlots: { customRender: 'price' }},
  { title: '今流', align:'center', dataIndex: 'stock_liuru_zhanbi', key: 'stock_liuru_zhanbi',sorter:()=>{}, scopedSlots: { customRender: 'price' }},
  // { title: '昨流', align:'center', dataIndex: 'stock_yesterday_liuru', key: 'stock_yesterday_liuru',sorter:()=>{}, scopedSlots: { customRender: 'price' }},
  { title:'931',  align:'center', dataIndex: 'stock_precent', key: 'stock_precent', scopedSlots: { customRender: 'price' }},
  { title:'932',  align:'center', dataIndex: 'two_stock_precent', key: 'two_stock_precent', scopedSlots: { customRender: 'price' }},
  { title:'1GP',  align:'center', dataIndex: 'stock_gap_precent', key: 'stock_gap_precent', scopedSlots: { customRender: 'price' }},
  { title:'2GP',  align:'center', dataIndex: 'two_stock_gap_precent', key: 'two_stock_gap_precent', scopedSlots: { customRender: 'price' }},
  { title: 'YRSI', align:'center', dataIndex: 'yesterday_stock_rsi6', key: 'yesterday_stock_rsi6'},
//   { title: 'OPT',  align:'left', dataIndex: 'fs_one_opt', key: 'fs_one_opt',sorter:()=>{}, scopedSlots: { customRender: 'opt' }},
  { title: '流通', align:'center', dataIndex: 'stock_liutongshizhi', key: 'stock_liutongshizhi', scopedSlots: { customRender: 'stock_zongzhi' },sorter:()=>{}}, 
  { title:'VER',  align:'center', dataIndex: 'ver', key: 'ver'},
//   { title: '实际', align:'center', dataIndex: 'stock_shiji_liutong', key: 'stock_shiji_liutong', scopedSlots: { customRender: 'price' },sorter:()=>{}}, 
//   { title: '流值',  align:'left', dataIndex: 'stock_zongzhi', key: 'stock_zongzhi',sorter:()=>{}, scopedSlots: { customRender: 'price' }},
//   { title: 'rsi6', align:'center', dataIndex: 'stock_rsi6', key: 'stock_rsi6',sorter:()=>{}},
//   { title: 'cha', align:'center', dataIndex: 'stock_rsi6_cha', key: 'stock_rsi6_cha',sorter:()=>{}},
//   { title: 'rsi6', align:'center', dataIndex: 'stock_rsi6', key: 'stock_rsi6',sorter:()=>{}},
  // { title: 'zuixin', align:'center', dataIndex: 'stock_cha_zuixin', key: 'stock_cha_zuixin',sorter:()=>{}},

  // { title: 'stock_kick', align:'center', dataIndex: 'stock_kick_time', key: 'stock_kick_time',sorter:()=>{}},

  // { title: 'stock_updatetime', align:'center', dataIndex: 'stock_updatetime', key: 'stock_updatetime'},
]

import C_ITEMS from '@/utils/items'
import ranges from "@/common/mixins/ranges"
import moment from 'moment'
import tableMixins from '@/common/mixins/table'

export default {
  name: 'operation',
  provide() {
    return {
      parent: this
    }
  },

  components: {
    // refundModal
  },

  data() {
    this.chartSettings = {
        xAxisType: ['KMB', 'percent'],
      }
      this.markLine = {
          symbol: ['none', 'none'], //去掉箭头
          data: [],
          label:{
              position:'insideStartTop'
          }
      },
      this.tooltip = {
          show:true,  
          trigger: "axis",
          alwaysShowContent:true,
          formatter: function(params) { 
            var res;
            //console.log(params)
            return res;
          }
        },
      this.chartStockSettings = {
        yAxis:{
          show:false,
        },
        grid: {
          containLabel: true,
        },
        showDataZoom: false,
        start: 0,
        end: 100,
        showMA: false,
        MA: [5,10],
        legendName: {}, 
        showVol: false,
        upColor: '#FF8787',
        downColor: '#7FB77E',
      }
      this.markLine = {
          symbol: ['none', 'none'], //去掉箭头
          data: [],
          label:{
              show: false, //隐藏标示文字
              position:'insideEndTop'
          }
      },
      this.toolbox = {
          feature: {
          magicType: {},
          saveAsImage: {pixelRatio:2}
          }
      }
    return {
      loading: false,
      fsVisible:false,
      first:0,
      pageSizeOptions: ['10', '20', '30', '40', '100'],
      stock_types:[
          {filter_name:'zoro'},
          {filter_name:'zoro_avg'},
          {filter_name:'zoro_quiet'},
          {filter_name:'zoro_zhenfu'},
          {filter_name:'zoro_xiao'},
          {filter_name:'zoro_zhong'},
      ],
      current: 1,
      pageParams: {
        currentPage: 1,
        pageCount: 50,
        perPage: 10,
        totalCount: 0
      },
      fs_list:[],
      fs_list_chart:[],
      kick_his_list:[],
      stock_title:'',
      stock_detail:{},
      columns,
      columns2,
      ztcolumns,
      searchParams: {
        "page": 1,
        "per-page": 10,
        "search": {},
        "sort": ''
      },
      list: [],
      operationTypes: C_ITEMS.operationTypes,
      searchData: {
        stock_type:['zoro_avg'],
        shsz:'sz',
        bk_sort:'2',
        stock_status:1,
        stock_day_sort:7,
      },
      visible: false,
      editVisible:false,
      refundVisible: false,
      exportLoading: false,
      histogramChartExtend:{
        series(item){
                if(item){
                    item[0].barMaxWidth = 10
                    item[0].color='#23d9ae'

                    if(item[1]){
                      item[1].barMaxWidth = 10;
                      item[1].color='red'
                    }

                    if(item[2]){
                      item[2].barMaxWidth = 10;
                      item[2].color='black'
                    }

                    if(item[3]){
                      item[3].barMaxWidth = 10;
                      item[3].color='#FF6600'
                    }
                }
                return item
            },
            xAxis:{
                axisLine:{
                    show:true,
                    lineStyle: {
                        type: 'dotted',
                    }
                },
            },
            yAxis(item){
                item[0].axisLine = Object.assign({}, {
                    show:false
                })
                item[0].splitLine = Object.assign({}, {
                    show:true,
                    lineStyle: {
                        type: 'dotted'
                    }
                })
                return item
            },
        },
         columns4,
          sort_list:{
            "2": 925,
            "3": 930,
            "4": 935,
            "5": 940,
            "6": 945,
            "7": 950,
            "8": 955,
            "9": 1000,
            "10": 1005,
            "11": 1010,
            "12": 1015,
            "13": 1020,
            "14": 1025,
            "15": 1030,
            "16": 1035,
            "17": 1040,
            "18": 1045,
            "19": 1050,
            "20": 1055,
            "21": 1100,
            "22": 1105,
            "23": 1110,
            "24": 1115,
            "25": 1120,
            "26": 1125,
            "27": 1130,
            "28": 1135,
            "29": 1300,
            "30": 1305,
            "31": 1310,
            "32": 1315,
            "33": 1320,
            "34": 1325,
            "35": 1330,
            "36": 1335,
            "37": 1340,
            "38": 1345,
            "39": 1350,
            "40": 1355,
            "41": 1400,
            "42": 1405,
            "43": 1410,
            "44": 1415,
            "45": 1420,
            "46": 1425,
            "47": 1430,
            "48": 1435,
            "49": 1440,
            "50": 1445,
            "51": 1450,
            "52": 1455,
            "53": 1500,
            "54": 1505
        },
        pie:{},
        dVisible:false,
        concept_name:'',
        dlLoading:false,
        detail_list:[],
        liuruChart:[],
        stockCode:'',
        predictMsg:[],
        stockChartData:[],
        dailyChart:[],
        predictChart:[],
        orderBookChart:[],
        predictLiuruChart:[],
        loadingP:false,
        liuruList:[],
    }
  },
  mixins: [ ranges, tableMixins ],
  created() {
    this.searchData.date = moment().subtract('days',0).format('YYYY-MM-DD');
  },
  methods: {
    updateFs(){
      console.log('test');
    },
    disabledDate(current) {
        const day = current.day();
        return day === 0 || day === 6;
    },
    handleDateChange(e){
      this.searchData.date = e.format('YYYY-MM-DD');
      this.getList()
    },
    handleButChange(e){
        this.searchData.shsz = e.target.value
        this.getList()
    },
    handleSort(e){
        this.searchData.bk_sort = e.target.value;
        this.getDetail(this.concept_name)
    },
    filterOption(input, option) {
        return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    onFsChange(date, dateString) {
        this.paramsData.search.stock_date = dateString
        this.getPredictChart(this.stockCode);
    },
    // handleButDateChange(e){
    //     this.searchData.bk_date = e.target.value
    //     this.getDetail(this.record)
    // },
    zuixincolor(value,target){
        if(Number(value) < Number(target)){
        return {color:'green'};
        }
        if(value==0){
        return '';
        }
        if(Number(value) > Number(target)){
        return {color:'red'};
        }
    },
    async clk_buy(stock_code,stock_name){
        let that = this;
        this.$confirm({
            title: 'Are you sure '+stock_name+'?',
            content: '',
            okText: 'Yes',
            okType: 'danger',
            cancelText: 'No',
            onOk() {
                that.loading = true
                let res = that.$store.dispatch('enterpriseLabStockMbuyAction', {data:{stock_code:stock_code}})
                that.loading = false
            },
            onCancel() {
                console.log('Cancel');
            },
        });
        console.log(stock_code);
    },
    async getDetail(keyword,add) {
            this.searchData.keyword = keyword;
            this.dVisible = true;
            this.dlLoading = true;
            let obj = {}
            let { searchData } = this
            if (searchData) {
                for (let k in searchData) {
                    obj[k] = searchData[k]
                }
            }
            obj['start_date'] = this.searchData.date
            obj['end_date'] = this.searchData.date
            // obj['main_filter'] = 1
            if(add){
                obj['add'] = add;
            }  
            this.searchParams.search = obj
            let _seach = this.searchParams;
            _seach.sort='stock_zhangdiefu';
            let res = await this.$store.dispatch('enterpriseLabStockBkDetailAction', { data: _seach })
            this.detail_list = [];
            this.detail_list = res.data.list
            this.liuruChart = res.data.liuru_chart
            this.dlLoading = false;
        },
    clkFs(data){
        this.fsVisible = true;
        this.fs_list = data.sub_fs;
        this.fs_list_chart = data.sub_fs_chart;
    },
    closeSearch() {
      this.visible = false
    },
    async handleOk() {
        this.getPredictChart(this.stockCode)  
    },
    clk(concept_name){
      this.concept_name=concept_name;
      this.getDetail(concept_name);
    },
    handleButTypeChange(e){
        this.searchData.bk_stock_type = e.target.value
        this.getDetail(this.concept_name)
    },
    handleButDateChange(e){
        this.searchData.bk_date = e.target.value
        this.getDetail(this.concept_name)
    },
    handleModalButChange(e){
        this.searchData.shsz = e.target.value
        this.getDetail(this.concept_name)
    },
    handleButAddChange(){
        this.getDetail(this.concept_name,1)
    },
    async getPredictChart(stock_code) {
      // this.editVisible = true;
      this.loadingP = true;
      let res = await this.$store.dispatch('enterpriseLabKplRankAction', {data:{search:this.searchData}})
      this.predictLiuruChart = res.data.main_list_chart;
      this.loadingP = false
    },
    color(value){
        if(value < 0){
          return {color:'green'};
        }
        if(value==0){
          return '';
        }
        if(value > 0){
          return {color:'red'};
        }
    },
    formatNumber(value) {
      let flag = '';
      if(value<0){
        value=Math.abs(value)
        flag = '-';
      }
      if (value >= 100000000) {
        return flag+(value / 100000000).toFixed(2) + ' 亿';
      } else if (value >= 10000) {
        return flag+(value / 10000).toFixed(2) + ' 万';
      } else if (value >= 1000) {
        return flag+(value / 1000).toFixed(2) + ' 千';
      } else {
        return flag+value;
      }
    },
    handleChange(pagination, filters, sorter){
        if(sorter.order){
            console.log(sorter);
            if(sorter.order === "ascend"){
                this.searchParams['sort'] = `${sorter.column.key}`
            }else{
                this.searchParams['sort'] = `-${sorter.column.key}`
            }
            }else{
            this.searchParams['sort'] = ''
            }
        this.getList()
    },
    handleChange2(pagination, filters, sorter){
        if(sorter.order){
            if(sorter.order === "ascend"){
                this.searchParams['sort'] = `${sorter.column.key}`
            }else{
                this.searchParams['sort'] = `-${sorter.column.key}`
            }
            }else{
            this.searchParams['sort'] = ''
        }
        this.getDetail(this.concept_name)
    },
    async getList() {
      this.loading = true
      //if(this.searchData.stock_code)
      this.getPredictChart(this.searchData.stock_code)
      this.loading = false
    }
  }
}
</script>

<style lang="scss" scoped>
.cell-content {
  white-space: normal; /* 允许换行 */
  word-wrap: break-word; /* 长单词换行 */
}
.ant-modal-body .ant-row{
    margin: 10px 20px !important;
}
</style>